import { css } from '@mui/material/styles';
export const dialogComponentOverrides = {
    MuiDialog: {
        styleOverrides: {
            root: ({ theme }) => css `
                & .MuiDialog-paper {
                    box-shadow: ${theme.tokens.FuelShadowBase};
                    border-radius: ${theme.tokens.FuelBorderRadiusLg};
                }

                & .MuiDialog-paperFullScreen {
                    border-radius: 0;
                }
            `
        }
    },
    MuiDialogTitle: {
        styleOverrides: {
            root: ({ theme }) => css `
                display: flex;
                align-items: center;
                margin-right: ${theme.tokens.FuelSpacing1};
                font-size: ${theme.tokens.FuelFontSizeXl} !important;
                line-height: ${theme.tokens.FuelLineHeightXl};
                justify-content: space-between;
                padding: ${theme.tokens.FuelSpacing4} ${theme.tokens.FuelSpacing6};
                height: 72px;
            `
        }
    },
    MuiDialogContent: {
        styleOverrides: {
            root: ({ ownerState }) => {
                const hasDividers = ownerState.dividers;
                return {
                    flex: '1 1 auto',
                    overflowY: 'auto',
                    padding: '0 24px 20px 24px',
                    ...hasDividers && {
                        padding: '20px 24px 20px 24px'
                    }
                };
            }
        }
    },
    MuiDialogActions: {
        styleOverrides: {
            root: () => css `
                padding: 1rem;
            `
        }
    }
};
